export const SET_PRICING = 'pricing/set'
